/** Dutch short month names, index 0 = januari. */
export const MONTH_LABELS = [
    'jan',
    'feb',
    'mrt',
    'apr',
    'mei',
    'jun',
    'jul',
    'aug',
    'sep',
    'okt',
    'nov',
    'dec',
];
/** Format an ISO `YYYY-MM-DD` string as `12 mrt 2027` (nl-NL). Empty → `—`. */
export function fmtDate(iso) {
    if (!iso)
        return '—';
    const d = new Date(iso + 'T00:00:00');
    if (Number.isNaN(d.getTime()))
        return iso;
    return d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
}
/**
 * Whole days from today until `iso` (negative = in the past). Null when the
 * date is missing/invalid. Ported from the prototype `daysTo`.
 */
export function daysTo(iso, now = new Date()) {
    if (!iso)
        return null;
    const d = new Date(iso + 'T00:00:00');
    if (Number.isNaN(d.getTime()))
        return null;
    const today = new Date(now.toDateString());
    return Math.round((d.getTime() - today.getTime()) / 86400000);
}
/** Label a `YYYY-MM` month key as `mrt 2027`. Empty → ``. */
export function monthLabel(m) {
    if (!m)
        return '';
    const parts = m.split('-');
    const year = parts[0] ?? '';
    const mo = Number(parts[1]);
    const name = MONTH_LABELS[mo - 1] ?? '';
    return `${name} ${year}`.trim();
}
/**
 * Een echte kalenderdatum als `YYYY-MM-DD`: vier cijfers jaar, bestaande maand
 * en dag (geen 31 februari). Alleen de vorm en de kalender; of het jaar
 * geloofwaardig is beslist `datumPlausibel`.
 */
export function isIsoDatum(waarde) {
    if (typeof waarde !== 'string')
        return false;
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(waarde);
    if (!m)
        return false;
    const jaar = Number(m[1]);
    const maand = Number(m[2]);
    const dag = Number(m[3]);
    if (maand < 1 || maand > 12 || dag < 1)
        return false;
    // Dag 0 van de volgende maand is de laatste dag van deze maand.
    const dagenInMaand = new Date(Date.UTC(jaar, maand, 0)).getUTCDate();
    return dag <= dagenInMaand;
}
/**
 * Twee grenzen voor datums die iemand intypt.
 *
 * `hard` is wat de server weigert: buiten deze jaren is het nooit een echte
 * datum uit deze administratie, hoogstens een tussenstand van een datumveld
 * (typ "2" in het jaar en Chrome levert 0002). `plausibel` is wat het scherm
 * zonder vragen aanneemt; daarbuiten vraagt het om een bevestiging, want een
 * koppeling uit 1998 of over drie jaar kán de bedoeling zijn.
 */
export const DATUM_GRENZEN = {
    hard: { van: 1900, tot: 2100 },
    plausibel: { van: 2000, jarenVooruit: 1 },
};
/** Een echte datum binnen de harde grenzen; wat de server aanneemt. */
export function isAanvaardbareDatum(waarde) {
    if (!isIsoDatum(waarde))
        return false;
    const jaar = Number(waarde.slice(0, 4));
    return jaar >= DATUM_GRENZEN.hard.van && jaar <= DATUM_GRENZEN.hard.tot;
}
/** Of een (aanvaardbare) datum geloofwaardig is zonder er iets over te vragen. */
export function datumPlausibel(iso, now = new Date()) {
    if (!isAanvaardbareDatum(iso))
        return false;
    const jaar = Number(iso.slice(0, 4));
    return (jaar >= DATUM_GRENZEN.plausibel.van &&
        jaar <= now.getFullYear() + DATUM_GRENZEN.plausibel.jarenVooruit);
}
//# sourceMappingURL=dates.js.map